import React from "react";

const CustomTab = ({
  tabs = [],
  activeTab = 0,
  onTabChange = () => null,
  showContainer = false,
  children = null,
  overflow = false,
  showLimited = false,
  className
}) => {
  return (
    showLimited ? null :
      <div className={`bg-white rounded-md ${className}`}>
        <div
          className={`flex items-center gap-1 p-2 ${overflow ? "overflow-x-scroll !scrollbar-hide md:overflow-x-hidden" : "overflow-x-auto"
            } !scrollbar-hide `}
        >
          <div className="flex gap-2">
            {tabs?.map((tab, index) => (
              <div
                key={index}
                className={`flex-shrink-0 px-4 py-2 cursor-pointer rounded-md text-sm whitespace-nowrap transition-all 
                ${Number(activeTab) === index
                    ? "bg-gradient-to-r from-[#1E3A8A] to-[#3B82F6] text-white"
                    : "bg-light text-theme hover:text-theme hover:bg-bghoverlight"
                  }`}
                onClick={() => onTabChange(index)}
              >
                {tab?.label}
              </div>
            ))}
            {children}
          </div>
        </div>

        {showContainer && (
          <TabContainer tabs={tabs} activeTab={activeTab} />
        )}
      </div>
  );
};

export const TabContainer = ({ tabs, activeTab }) => {
  return <div className="h-full">{tabs[activeTab]?.content}</div>;
};

export default CustomTab;
